import { render, staticRenderFns } from "./ImportApplications.vue?vue&type=template&id=2bbdd6be&"
import script from "./ImportApplications.vue?vue&type=script&lang=ts&"
export * from "./ImportApplications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports